import axiosInstance from './axios';
import PickUpVerificationMethod from 'types/models/PickUpVerificationMethod';

export const getPickUpVerificationMethods = async (): Promise<PickUpVerificationMethod[]> => {
  try {
    const { data } = await axiosInstance({
      method: 'get',
      url: `pickupverificationmethods`,
    });
    return parsePickUpVerificationMethods(data);
  } catch (error) {
    console.log(error);
    return [];
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parsePickUpVerificationMethods = (pickUpVerificationMethods: any[]): PickUpVerificationMethod[] => {
  return pickUpVerificationMethods.map((pickUpVerificationMethod: any) =>
    parsePickUpVerificationMethod(pickUpVerificationMethod),
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parsePickUpVerificationMethod = (pickUpVerificationMethod: any): PickUpVerificationMethod => {
  return {
    id: pickUpVerificationMethod.id,
    method: pickUpVerificationMethod.method,
    description: pickUpVerificationMethod.description,
  };
};
